<template>
  <!--
    Situação do registro diário (#7286, Cenário 2). Replica o comportamento do
    ESituacaoAula do Diário Online — as mesmas 5 situações e motivo obrigatório em duas
    delas — mas com nomenclatura de atendimento, sem a palavra "Aula".
  -->
  <span>
    <v-menu v-if="podeAlterar" bottom>
      <template v-slot:activator="{ on, attrs }">
        <v-chip
          :id="`situacao-atendimento-${atendimento.id}`"
          :color="color"
          small
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ descricaoSituacao }}
        </v-chip>
      </template>
      <v-list dense>
        <v-list-item
          v-for="situacao of $constants.situacoesAtendimentos"
          :key="situacao.descricao"
          :id="`situacao-opcao-${atendimento.id}-${slug(situacao.descricao)}`"
          link
          @click="() => selecionar(situacao.descricao)"
        >
          <v-list-item-title>{{ situacao.descricao }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>

    <v-chip v-else :id="`situacao-atendimento-${atendimento.id}`" :color="color" small dark>
      {{ descricaoSituacao }}
    </v-chip>

    <v-dialog v-model="dialog" width="500">
      <v-card>
        <v-card-title class="primary">
          <span class="text-h5 white--text">Informar motivo</span>
        </v-card-title>
        <v-col cols="12">
          <v-textarea
            :id="`input-motivo-atendimento-${atendimento.id}`"
            v-model="motivo"
            label="Descreva o motivo"
            counter="255"
            maxlength="255"
            autofocus
            dense
            solo
          />
        </v-col>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn :id="`btn-cancelar-motivo-${atendimento.id}`" color="red" text @click="cancelar">
            Cancelar
          </v-btn>
          <v-btn
            :id="`btn-enviar-motivo-${atendimento.id}`"
            color="primary"
            text
            :disabled="!motivo"
            @click="confirmarComMotivo"
          >
            Enviar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
// Mesmas situações que o Diário Online abre modal antes de gravar.
const SITUACOES_QUE_EXIGEM_MOTIVO = ["Atendimento inválido", "Atendimento rejeitado por falta"];

export default {
  name: "ESituacaoAtendimento",
  props: {
    atendimento: {
      type: Object,
      required: true,
    },
    gestaoId: {
      type: [String, Number],
      required: true,
    },
  },
  data() {
    return {
      dialog: false,
      motivo: null,
      situacaoPendente: null,
    };
  },
  computed: {
    podeAlterar() {
      return this.$can(["atendimentosAuxiliares.atualizarSituacao", "atendimentosAuxiliares.*"]);
    },
    descricaoSituacao() {
      return this.atendimento.descricaoSituacao;
    },
    color() {
      return this.atendimento.color;
    },
  },
  methods: {
    slug(texto) {
      return String(texto)
        .toLowerCase()
        .normalize("NFD")
        .replace(/[̀-ͯ]/g, "")
        .replace(/[^a-z0-9]+/g, "-")
        .replace(/(^-|-$)/g, "");
    },
    selecionar(novaSituacao) {
      if (novaSituacao === this.descricaoSituacao) return;

      if (SITUACOES_QUE_EXIGEM_MOTIVO.includes(novaSituacao)) {
        this.motivo = this.atendimento.motivo;
        this.situacaoPendente = novaSituacao;
        this.dialog = true;
        return;
      }

      this.alterar(novaSituacao, null);
    },
    cancelar() {
      this.dialog = false;
      this.motivo = null;
      this.situacaoPendente = null;
    },
    confirmarComMotivo() {
      const situacao = this.situacaoPendente;
      this.dialog = false;
      this.alterar(situacao, this.motivo);
    },
    async alterar(situacao, motivo) {
      this.$loaderService.open("Alterando situação...");
      try {
        await this.$services.atendimentosAuxiliaresService.alterarSituacao(
          this.gestaoId,
          this.atendimento.id,
          situacao,
          motivo
        );
        this.$toast.success("Situação alterada");
        this.$emit("alterado");
      } catch (error) {
        this.$handleError(error);
      }
      this.situacaoPendente = null;
      this.$loaderService.close();
    },
  },
};
</script>
